module.exports = "https://cdn.hellotech.com/client-assets/universal_remotes_desktop_86431e2084add03a3c01d44e08261327.png";